export const handlePlurals = (word: string, amount?: number) => {
    if (!amount || amount > 1) {
        return `${word}s`;
    } else {
        return word;
    }
};
